import React from 'react'
import styles from './Main.module.scss'
import { InitialPage } from '../../components/initialPage/InitialPage'
import { Advantages } from '../../components/Advantages/Advantages'
import {Services} from "../../components/Services/Services"
import {SliderAdvantages} from '../../components/SliderAdvantages/SliderAdvantages'
import { Portfolio } from '../../components/Portfolio/Portfolio'
import { Scheme } from '../../components/Scheme/Scheme'

export const Main = ({isOpen, isImageOpen}) => {

    return (
        <section className={styles.main}>
            <InitialPage
                isOpen ={isOpen}
            />
            <SliderAdvantages/>
            <Services
                isOpen ={isOpen}
            />
            <Advantages/>
            <Portfolio
                isImageOpen={isImageOpen}
            />
            <Scheme/>
            <SliderAdvantages/>
        </section>
    )
}